import React from 'react';
import Icon from '../../assets/icons';
import { DividerWrapper } from './styles';

const DoteDivider = () => (
  <DividerWrapper>
    <Icon variant='divider' />
  </DividerWrapper>
);

export default DoteDivider;
